import { getAccountCapabilities, type Capability } from './capabilities';
import {
  getActiveScopedRelationships,
  SCOPED_RELATIONSHIP_CAPABILITIES,
} from './scopedRelationshipResolver';
import type { User } from '@/types';

/**
 * Capabilities that may make a top-level surface or launcher discoverable.
 * Exact route, record and mutation authorization must still call the canonical
 * scoped resolver with a concrete resource context.
 */
export function getEffectiveSurfaceCapabilities(
  user: User | null | undefined,
): Capability[] {
  if (!user || user.status === 'suspended') return [];
  const capabilities = new Set<Capability>(getAccountCapabilities(user));
  for (const relationship of getActiveScopedRelationships(user)) {
    for (const capability of SCOPED_RELATIONSHIP_CAPABILITIES[relationship.type] ?? []) {
      capabilities.add(capability);
    }
  }
  return [...capabilities];
}
